import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { DesignList } from '../../../Design/components'
import { useGetCustomerProfileDesigns } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function CustomerProfileDesigns(props) {
  const { customerProfile } = props

  // [ADDITIONAL_HOOKS]
  const [designs, loading] = useGetCustomerProfileDesigns(customerProfile)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : designs?.length ? (
            <DesignList {...props} hideAddCard designs={designs} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No designs have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

CustomerProfileDesigns.propTypes = {
  customerProfile: PropTypes.object.isRequired
}
